import { render, staticRenderFns } from "./CustomFileInput.vue?vue&type=template&id=2f252f57&scoped=true&"
import script from "./CustomFileInput.vue?vue&type=script&lang=js&"
export * from "./CustomFileInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomFileInput.vue?vue&type=style&index=0&id=2f252f57&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f252f57",
  null
  
)

export default component.exports